import { render, staticRenderFns } from "./StarBg.vue?vue&type=template&id=b89fdcb4&"
import script from "./StarBg.vue?vue&type=script&lang=ts&"
export * from "./StarBg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports